import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import * as styles from '../../../styles';
import {imageUrl} from '../../../utilities/requests';


export default class PrintSchoolReport extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    render() {
        const subjects = _.mapKeys(this.props.examination.subjects, item => item.id);
        const rootSubjects = _.uniq(_.union(..._.map(
            this.props.examination.questions,
            item => _.map(item.subjects, item => item.root_subject),
        )));
        const Td = props => <td {...props} style={{...styles.softTd, ...(props.style || {})}}>{props.children}</td>;
        const Mtd = props => <td {...props} style={{...styles.softTd, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </td>;
        const Th = props => <th {...props} style={{...styles.softTh, ...(props.style || {})}}>{props.children}</th>;
        const Mth = props => <th {...props} style={{...styles.softTh, textAlign: 'center', ...(props.style || {})}}>
            {props.children}
        </th>;
        return <div
            style={{
                fontSize: '.9em',
                position: 'relative',
                width: '209mm',
                height: '295mm',
                pageBreakAfter: this.props.last ? undefined : 'always',
            }}>
            <div
                style={{
                    position: 'fixed',
                    top: '26mm',
                    right: '46mm',
                    width: '52mm',
                    fontSize: '1.65em',
                }}>
                <div style={{textAlign: 'center'}}>
                    <b>
                        {this.props.classView
                            ? window.gettext('Class Report')
                            : window.gettext('School Report')
                        }
                    </b>
                </div>
            </div>
            <div
                style={{
                    position: 'fixed',
                    top: '8mm',
                    right: '102mm',
                    width: '63.2mm',
                }}>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('School Name')}:</b>&nbsp;
                    {this.props.school.name} - {this.props.school.city.name}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em', fontSize: '.9em'}}>
                    <b>{window.gettext('Examination')} - {window.gettext('Grade')}:</b>&nbsp;
                    {this.props.examination.title} - {this.props.examination.grades[0].title}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Holding Date')}:</b> {this.props.examination.date.toJalali().persian()}
                </div>
            </div>
            <div
                style={{
                    position: 'fixed',
                    top: '8mm',
                    right: '167mm',
                    width: '42mm',
                }}>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Participants')}:</b>
                    &nbsp;
                    {(this.props.examination.students_participated || '').persian()}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Centers Participated')}:</b>
                    &nbsp;
                    {(this.props.examination.schools_participated || '').persian()}
                </div>
                <div style={{overflow: 'hidden', whiteSpace: 'nowrap', height: '2.3em'}}>
                    <b>{window.gettext('Rank Among Schools')}:</b>
                    &nbsp;
                    {(_.find(this.props.data, data => (
                        data.category_is_global &&
                        data.school === this.props.school.id &&
                        data.field === 31 &&
                        data.group_is_global
                    )) || {value: 0}).value.toFixed().persian()}
                </div>
            </div>
            <img
                style={{
                    position: 'fixed',
                    top: '4mm',
                    right: '4.5mm',
                    width: '33mm',
                }}
                src={imageUrl(window.images.logo, {
                    width: 200,
                    type: 'contain',
                })}
                onLoad={this.props.imageLoaded}
                onError={this.props.imageLoaded}
            />
            {/* <div */}
            {/*     style={{ */}
            {/*         position: 'fixed', */}
            {/*         top: '195mm', */}
            {/*         right: '16mm', */}
            {/*         width: '71mm', */}
            {/*     }}> */}
            {/*     <div style={{overflow: 'hidden', height: '2.3em'}}> */}
            {/*         <b>{window.gettext('Analyze Date')}:</b> {(this.props.examination.analyze_date || '').persian()} */}
            {/*     </div> */}
            {/* </div> */}
            {/* <div */}
            {/*     style={{ */}
            {/*         position: 'fixed', */}
            {/*         top: '195mm', */}
            {/*         right: '120mm', */}
            {/*         fontSize: '1.3em', */}
            {/*         fontFamily: 'Arial', */}
            {/*     }}> */}
            {/*     <b>www.mhelli.ir</b> */}
            {/* </div> */}
            <div
                style={{
                    position: 'fixed',
                    top: '40mm',
                    left: '12mm',
                    right: '7mm',
                }}>
                <table
                    style={{
                        borderCollapse: 'collapse',
                        fontSize: '1.1em',
                        border: '.0625em solid #eaeaea',
                        width: 'calc(50% - 2em)',
                        marginRight: '1em',
                    }}>
                    <thead>
                        <tr>
                            <Mth rowSpan='2' style={{lineHeight: undefined}}>{window.gettext('Total Score')}</Mth>
                            <Mth
                                colSpan='2'
                                style={{
                                    borderLeft: '.0625em solid #cacaca',
                                    borderRight: '.0625em solid #cacaca',
                                    lineHeight: undefined,
                                }}>
                                {window.gettext('Average for school')}
                            </Mth>
                            <Mth
                                colSpan='3'
                                style={{borderRight: '.0625em solid #cacaca', lineHeight: undefined}}>
                                {window.gettext('Country')}
                            </Mth>
                        </tr>
                        <tr>
                            <Mth style={{borderRight: '.0625em solid #cacaca', lineHeight: undefined}}>
                                {window.gettext('Score')}
                            </Mth>
                            <Th style={{borderLeft: '.0625em solid #cacaca', lineHeight: undefined}}>
                                {window.gettext('Status')}
                            </Th>
                            <Mth style={{borderRight: '.0625em solid #cacaca', borderRight: '.0625em solid #cacaca'}}>
                                {window.gettext('Average')}
                            </Mth>
                            <Mth style={{lineHeight: undefined}}>{window.gettext('Rank')}</Mth>
                            <Mth style={{lineHeight: undefined}}>{window.gettext('Top 4th')}</Mth>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <Mtd>
                                {_.sumBy(
                                    this.props.examination.questions,
                                    question => _.sumBy(question.scores, 'score'),
                                ).toFixed(2).persian(true)}
                            </Mtd>
                            <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                {(_.find(this.props.data, data => (
                                    data.category_is_global &&
                                    data.school === this.props.school.id &&
                                    data.field === 21
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                            <Td style={{borderLeft: '.0625em solid #cacaca'}}>
                                {(_.find(this.props.data, data => (
                                    data.category_is_global &&
                                    data.school === this.props.school.id &&
                                    data.field === 21 &&
                                    data.group_is_global
                                )) || {value: 0}).value.scoreStatus(_.sumBy(
                                    this.props.examination.questions,
                                    question => _.sumBy(question.scores, 'score'),
                                ))}
                            </Td>
                            <Mtd>
                                {(_.find(this.props.data, data => (
                                    data.category_is_global &&
                                    data.field === 21 &&
                                    data.is_global
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                            <Mtd>
                                {(_.find(this.props.data, data => (
                                    data.category_is_global &&
                                    data.school === this.props.school.id &&
                                    data.field === 31 &&
                                    data.group_is_global
                                )) || {value: 0}).value.toFixed().persian()}
                            </Mtd>
                            <Mtd>
                                {(_.find(this.props.data, data => (
                                    data.category_is_global &&
                                    data.field === 23 &&
                                    data.is_global
                                )) || {value: 0}).value.toFixed(2).persian(true)}
                            </Mtd>
                        </tr>
                    </tbody>
                </table>
                <div
                    style={{
                        width: '100%',
                        boxSizing: 'border-box',
                        padding: '1em',
                        textAlign: 'center',
                    }}>
                    <span>
                        {this.props.classView
                            ? window.gettext('Examining the status of classes in subjects of the examinaiton')
                            : window.gettext('Examining the status of the school in subjects of the examinaiton')
                        }
                    </span>
                    <table
                        style={{
                            borderCollapse: 'collapse',
                            width: '100%',
                            border: '.0625em solid #eaeaea',
                        }}>
                        <thead>
                            <tr>
                                <Th rowSpan='2'>{window.gettext('Index')}</Th>
                                <Th rowSpan='2'>{window.gettext('Subject')}</Th>
                                <Mth rowSpan='2'>{window.gettext('Count')}</Mth>
                                <Mth rowSpan='2'>{window.gettext('Total Score')}</Mth>
                                {this.props.classView
                                    ? _.map(
                                        _.filter(
                                            this.props.school.classes,
                                            clazz => _.some(this.props.data, d => d.clazz === clazz.id),
                                        ),
                                        clazz => <Mth
                                            key={clazz.id}
                                            colSpan='2'
                                            style={{
                                                borderLeft: '.0625em solid #cacaca',
                                                borderRight: '.0625em solid #cacaca',
                                            }}>
                                            {window.interpolate(
                                                window.gettext('Average for class %(class)s'),
                                                {class: clazz.name},
                                                true,
                                            )}
                                        </Mth>,
                                    )
                                    : <Mth
                                        key='school'
                                        colSpan='2'
                                        style={{
                                            borderLeft: '.0625em solid #cacaca',
                                            borderRight: '.0625em solid #cacaca',
                                        }}>
                                        {window.gettext('Average for school')}
                                    </Mth>
                                }
                                <Mth
                                    key='country'
                                    colSpan='2'
                                    style={{borderRight: '.0625em solid #cacaca'}}>
                                    {window.gettext('Country')}
                                </Mth>
                            </tr>
                            <tr>
                                {this.props.classView
                                    ? _.map(
                                        _.filter(
                                            this.props.school.classes,
                                            clazz => _.some(this.props.data, d => d.clazz === clazz.id),
                                        ),
                                        clazz => [
                                            <Mth key={'score-' + clazz.id} style={{borderRight: '.0625em solid #cacaca'}}>
                                                {window.gettext('Score')}
                                            </Mth>,
                                            <Th key={'status-' + clazz.id} style={{borderLeft: '.0625em solid #cacaca'}}>
                                                {window.gettext('Status')}
                                            </Th>,
                                        ]
                                    )
                                    : [
                                        <Mth key='score' style={{borderRight: '.0625em solid #cacaca'}}>
                                            {window.gettext('Score')}
                                        </Mth>,
                                        <Th key='status' style={{borderLeft: '.0625em solid #cacaca'}}>
                                            {window.gettext('Status')}
                                        </Th>,
                                    ]
                                }
                                <Mth style={{borderRight: '.0625em solid #cacaca'}}>{window.gettext('Average')}</Mth>
                                <Mth>{window.gettext('Top 4th')}</Mth>
                            </tr>
                        </thead>
                        <tbody>
                            {_.map(
                                _.sortBy(rootSubjects),
                                (subject, index) => <tr key={subject}>
                                    <Td>{(index + 1).persian()}</Td>
                                    <Td>{subjects[subject].title}</Td>
                                    <Mtd>
                                        {_.size(_.filter(
                                            this.props.examination.questions,
                                            item => _.some(item.subjects, item => item.root_subject === subject),
                                        )).persian()}
                                    </Mtd>
                                    <Mtd>
                                        {_.sumBy(
                                            _.filter(
                                                this.props.examination.questions,
                                                item => _.some(item.subjects, item => item.root_subject === subject),
                                            ),
                                            item => _.sumBy(item.scores, 'score'),
                                        ).persian()}
                                    </Mtd>
                                    {this.props.classView
                                        ? _.map(
                                            _.filter(
                                                this.props.school.classes,
                                                clazz => _.some(this.props.data, d => d.clazz === clazz.id),
                                            ),
                                            clazz => [
                                                <Mtd
                                                    key={'score-' + clazz.id}
                                                    style={{borderRight: '.0625em solid #cacaca'}}>
                                                    {(_.find(this.props.data, data => (
                                                        data.subject === subject &&
                                                        data.clazz === clazz.id &&
                                                        data.field === 21
                                                    )) || {value: 0}).value.toFixed(2).persian(true)}
                                                </Mtd>,
                                                <Td
                                                    key={'status-' + clazz.id}
                                                    style={{borderLeft: '.0625em solid #cacaca'}}>
                                                    {(_.find(this.props.data, data => (
                                                        data.subject === subject &&
                                                        data.clazz === clazz.id &&
                                                        data.field === 21
                                                    )) || {value: 0}).value.scoreStatus(_.sumBy(
                                                        _.filter(
                                                            this.props.examination.questions,
                                                            item => _.some(
                                                                item.subjects,
                                                                item => item.root_subject === subject,
                                                            ),
                                                        ),
                                                        item => _.sumBy(item.scores, 'score'),
                                                    ))}
                                                </Td>,
                                            ]
                                        )
                                        : [
                                            <Mtd key='score' style={{borderRight: '.0625em solid #cacaca'}}>
                                                {(_.find(this.props.data, data => (
                                                    data.subject === subject &&
                                                    data.school === this.props.school.id &&
                                                    data.field === 21
                                                )) || {value: 0}).value.toFixed(2).persian(true)}
                                            </Mtd>,
                                            <Td key='status' style={{borderLeft: '.0625em solid #cacaca'}}>
                                                {(_.find(this.props.data, data => (
                                                    data.subject === subject &&
                                                    data.school === this.props.school.id &&
                                                    data.field === 21
                                                )) || {value: 0}).value.scoreStatus(_.sumBy(
                                                    _.filter(
                                                        this.props.examination.questions,
                                                        item => _.some(
                                                            item.subjects,
                                                            item => item.root_subject === subject,
                                                        ),
                                                    ),
                                                    item => _.sumBy(item.scores, 'score'),
                                                ))}
                                            </Td>,
                                        ]
                                    }
                                    <Mtd style={{borderRight: '.0625em solid #cacaca'}}>
                                        {(_.find(this.props.data, data => (
                                            data.subject === subject &&
                                            data.field === 21 &&
                                            data.is_global
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                    <Mtd>
                                        {(_.find(this.props.data, data => (
                                            data.subject === subject &&
                                            data.field === 23 &&
                                            data.is_global
                                        )) || {value: 0}).value.toFixed(2).persian(true)}
                                    </Mtd>
                                </tr>,
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;
    }
}
